import { DomStorage } from '@/enums'
import type { FeatureFlag } from './feature-flags'

type FeatureFlagsMap = Partial<Record<FeatureFlag, boolean>>

const isValidCache = (data: unknown): data is FeatureFlagsMap => {
  if (data === null || typeof data !== 'object' || Array.isArray(data)) {
    return false
  }

  for (const value of Object.values(data)) {
    if (typeof value !== 'boolean') {
      return false
    }
  }

  return true
}

const readCache = (): FeatureFlagsMap | null => {
  try {
    const cached = sessionStorage.getItem(DomStorage.FEATURE_FLAGS_CACHE)
    if (cached === null) {
      return null
    }

    const parsed = JSON.parse(cached)
    if (!isValidCache(parsed)) {
      return null
    }

    return parsed
  } catch {
    return null
  }
}

const writeCache = (flags: FeatureFlagsMap): void => {
  try {
    sessionStorage.setItem(
      DomStorage.FEATURE_FLAGS_CACHE,
      JSON.stringify(flags),
    )
  } catch {
    // Ignore if sessionStorage unavailable
  }
}

const clearCache = (): void => {
  try {
    sessionStorage.removeItem(DomStorage.FEATURE_FLAGS_CACHE)
  } catch {
    // Ignore if sessionStorage unavailable
  }
}

export default {
  readCache,
  writeCache,
  clearCache,
  isValidCache,
}
